import { DateTime } from "luxon";
export const contentChannel = {
  constant: [
    {
      value: "1",
      label: "SMS",
    },
    {
      value: "2",
      label: "Email",
    },
  ],
  getContentChannel() {
    return this.constant;
  },
  getLabelByValue(value) {
    const item = this.constant.find((item) => item.value == value);
    return item ? item.label : "";
  },
  getValueByLabel(label) {
    const item = this.constant.find((item) => item.label === label);
    return item ? item.value : "";
  },
};

export const timeZoneConstant = {
  constant: [
    { offset: "GMT-12", tz: "Etc/GMT+12", city: "Baker Island" },
    { offset: "GMT-11", tz: "Pacific/Midway", city: "Midway Atoll" },
    { offset: "GMT-10", tz: "Pacific/Honolulu", city: "Honolulu" },
    { offset: "GMT-10", tz: "America/Adak", city: "Adak" },
    { offset: "GMT-9", tz: "America/Anchorage", city: "Anchorage" },
    { offset: "GMT-8", tz: "America/Los_Angeles", city: "Los Angeles" },
    { offset: "GMT-7", tz: "America/Denver", city: "Denver" },
    { offset: "GMT-6", tz: "America/Chicago", city: "Chicago" },
    { offset: "GMT-5", tz: "America/New_York", city: "New York" },
    { offset: "GMT-4", tz: "America/Toronto", city: "Toronto" },
    { offset: "GMT-3", tz: "America/Sao_Paulo", city: "São Paulo" },
    { offset: "GMT-2", tz: "Atlantic/South_Georgia", city: "South Georgia" },
    { offset: "GMT-1", tz: "Atlantic/Azores", city: "Azores" },
    { offset: "GMT", tz: "Europe/London", city: "London" },
    { offset: "GMT+1", tz: "Europe/Paris", city: "Paris" },
    { offset: "GMT+1", tz: "Europe/Madrid", city: "Madrid" },
    { offset: "GMT+2", tz: "Africa/Blantyre", city: "Blantyre" },
    { offset: "GMT+2", tz: "Europe/Berlin", city: "Berlin" },
    { offset: "GMT+2", tz: "Europe/Rome", city: "Rome" },
    { offset: "GMT+3", tz: "Europe/Moscow", city: "Moscow" },
    { offset: "GMT+3", tz: "Asia/Istanbul", city: "Istanbul" },
    { offset: "GMT+4", tz: "Asia/Dubai", city: "Dubai" },
    { offset: "GMT+5", tz: "Asia/Karachi", city: "Karachi" },
    { offset: "GMT+6", tz: "Asia/Dhaka", city: "Dhaka" },
    { offset: "GMT+7", tz: "Asia/Jakarta", city: "Jakarta" },
    { offset: "GMT+7", tz: "Asia/Bangkok", city: "Bangkok" },
    { offset: "GMT+8", tz: "Asia/Shanghai", city: "Beijing" },
    { offset: "GMT+8", tz: "Asia/Singapore", city: "Singapore" },
    { offset: "GMT+8", tz: "Asia/Hong_Kong", city: "Hong Kong" },
    { offset: "GMT+9", tz: "Asia/Tokyo", city: "Tokyo" },
    { offset: "GMT+9", tz: "Asia/Seoul", city: "Seoul" },
    { offset: "GMT+10", tz: "Australia/Sydney", city: "Sydney" },
    { offset: "GMT+10", tz: "Pacific/Port_Moresby", city: "Port Moresby" },
    { offset: "GMT+11", tz: "Pacific/Noumea", city: "Nouméa" },
    { offset: "GMT+12", tz: "Pacific/Auckland", city: "Auckland" },
    { offset: "GMT+12", tz: "Pacific/Fiji", city: "Suva" },
  ],
  getTimeZoneList() {
    return  JSON.parse(JSON.stringify(this.constant))
      .map((item) => {
        const dt = DateTime.now().setZone(item.tz);
        const correctOffset = `${dt.offsetNameShort}`;
        return {
          ...item,
          offset: correctOffset,
        };
      })
      .sort((a, b) => {
        return (
          parseInt(a.offset.replace("GMT", "")) -
          parseInt(b.offset.replace("GMT", ""))
        );
      });
  },
  getTimeZoneByValue(value) {
    return this.getTimeZoneList().find((item) => item.tz === value);
  },
};

export const userTypeConstant = {
  MICROSOFT: "Microsoft",
  ATOM:'Atom'
}